// Central AdSense ad-unit slot IDs (web).
// Client: ca-pub-6528149778805400 (set in AdBanner + index.html).
//
// Each ID below is a real Display unit in the AdSense account, mapped to the
// screen whose name it matches. There are 6 units for 7 placements, so `codex`
// and `profile` reuse the closest-matching banner (a Display unit works on any
// page). To give those their own reporting, create dedicated units and swap the
// IDs here.
export const AD_SLOTS = {
  home: "2840514855",        // MystiCrafter - Home Page Banner
  gameplay: "6095758805",    // MystiCrafter - Gameplay Banner  (Forge / Lab / Battle)
  codex: "1331992066",       // MystiCrafter - Home Bottom      (Codex / Ranks)
  profile: "2840514855",     // MystiCrafter - Home Page Banner (reused for You / Profile)
  forumList: "5663679819",   // MystiCrafter - Forum Banner
  forumTopics: "8098271469", // MystiCrafter - Topic List
  forumThread: "6257015689", // MystiCrafter - Message Thread
} as const;
